const transformAddressList = (addressList) => {
  return addressList.map((address) => {
    const [lat, lng] = address.latLng.split(",").map(Number);
    return {
      ...address,
      latLng: [lat, lng],
    };
  });
};

const transformPositions = (positions) => {
  return positions.map((position) => ({
    lat: position.latitude,
    lng: position.longitude,
    date: position.createdAt,
    type: position.type,
    id: position.id,
    orderId: position.orderId,
    driverId: position.driverId,
  }));
};

const transformRouteData = (routeData) => {
  if (!routeData || !routeData.jsonData) return null;

  try {
    const coordinates = JSON.parse(routeData.jsonData);
    return coordinates;
  } catch (error) {
    console.error("Error parsing route data:", error);
    return null;
  }
};

const prepareCityData = (city) => {
  if (!city || typeof city.latitude !== "number" || typeof city.longitude !== "number") {
    console.warn("Invalid city data:", city);
    return null;
  }
  return {
    ...city,
    latitude: Number(city.latitude),
    longitude: Number(city.longitude),
  };
};

const prepareYandexMapData = (item, routeData) => {
  const transformedData = {
    addressList: item.order?.addressList ? transformAddressList(item.order.addressList) : [],

    coordinateTruck: item?.positions ? transformPositions(item.positions) : [],

    routeData: routeData ? transformRouteData(routeData) : null,

    cityFrom: item?.fromCity ? prepareCityData(item.fromCity) : null,
    cityTo: item?.toCity ? prepareCityData(item.toCity) : null,
  };

  return transformedData;
};

const validateMapData = (data) => {
  const errors = [];

  if (data.addressList?.length > 0) {
    data.addressList.forEach((address, index) => {
      if (!Array.isArray(address.latLng) || address.latLng.length !== 2) {
        errors.push(`Address ${index}: invalid latLng format`);
      }
      if (typeof address.latLng[0] !== "number" || typeof address.latLng[1] !== "number") {
        errors.push(`Address ${index}: latLng contains non-numeric values`);
      }
    });
  }

  if (data.coordinateTruck?.length > 0) {
    data.coordinateTruck.forEach((coord, index) => {
      if (typeof coord.lat !== "number" || typeof coord.lng !== "number") {
        errors.push(`Coordinate ${index}: invalid lat/lng format`);
      }
    });
  }

  if (
    data.cityFrom &&
    (typeof data.cityFrom.latitude !== "number" || typeof data.cityFrom.longitude !== "number")
  ) {
    errors.push("cityFrom: invalid coordinates");
  }

  if (
    data.cityTo &&
    (typeof data.cityTo.latitude !== "number" || typeof data.cityTo.longitude !== "number")
  ) {
    errors.push("cityTo: invalid coordinates");
  }

  return errors;
};

const transformMonthlyOrderIndicators = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  const groupedByDate = new Map();

  data.forEach((item) => {
    const date = item.createdAt;

    if (!groupedByDate.has(date)) {
      groupedByDate.set(date, {
        date: date,
        awning: 0,
        refrigerator: 0,
        isothermal: 0,
        covered: 0,
      });
    }

    const currentData = groupedByDate.get(date);

    switch (item.vehicle) {
      case "Тент":
        currentData.awning += item.count;
        break;
      case "Рефрижератор":
        currentData.refrigerator += item.count;
        break;
      case "Изотерм":
        currentData.isothermal += item.count;
        break;
      case "Крытый":
        currentData.covered += item.count;
        break;
      default:
        console.warn(`Unknown vehicle type: ${item.vehicle}`);
    }
  });

  return Array.from(groupedByDate.values()).sort((a, b) => {
    const dateA = new Date(a.date.split(".").reverse().join("-"));
    const dateB = new Date(b.date.split(".").reverse().join("-"));
    return dateA - dateB;
  });
};

const transformCompareOrderPrice = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }

  return data.map((item) => {
    const date = new Date(item.createdAt);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return {
      date: `${day}.${month}.${year}`,
      price: item.price,
      algoPrice: item.algoPrice,
    };
  }).sort((a, b) => {
    const dateA = new Date(a.date.split(".").reverse().join("-"));
    const dateB = new Date(b.date.split(".").reverse().join("-"));
    return dateA - dateB;
  });
};

const convertDateFormat = (dateString) => {
  if (typeof dateString !== 'string') return dateString;
  
  const parts = dateString.split('.');
  if (parts.length !== 3) return dateString;
  
  const [day, month, year] = parts;
  const isoDate = new Date(year, month - 1, day).toISOString();
  return isoDate;
};

const transformDateData = (data) => {
  if (!Array.isArray(data) || data.length === 0) return data;
  
  return data.map(item => ({
    ...item,
    createdAt: item.createdAt ? convertDateFormat(item.createdAt) : item.createdAt
  }));
};

export {
  transformAddressList,
  transformPositions,
  transformRouteData,
  prepareCityData,
  prepareYandexMapData,
  validateMapData,
  transformMonthlyOrderIndicators,
  transformCompareOrderPrice,
  transformDateData,
};